import { Renderer, Camera, Transform, Vec3, Orbit } from 'ogl'

export default class Canvas {
  constructor({ canvas }) {

    this.canvas = canvas instanceof HTMLElement ? canvas : document.querySelector(canvas)

    //Variables
    this.time = 0;
    //Methods
    this.createRenderer()
    this.createScene()
    this.createCamera()
    this.onResize()
    this.update()
    this.addEventListeners()
  }

  createRenderer() {
    this.renderer = new Renderer({
      canvas: this.canvas,
      alpha: true,
      antialias: true,
      dpr: Math.min(window.devicePixelRatio, 2),
    })
    this.gl = this.renderer.gl    
    // document.body.appendChild(this.gl.canvas)
  }

  createScene() {
    this.scene = new Transform()
  }

  createCamera() {
    //Doc : Coinstructor(gl, { near = 0.1, far = 100, fov = 45, aspect = 1, left, right, bottom, top, zoom = 1 } = {})
    // this.camera = new Camera(this.gl, { near: 1, far: 1000, fov: 45, aspect: this.viewport.width / this.viewport.height })
    this.camera = new Camera(this.gl)
    this.camera.position.z = 5
  }

  getSize() {
    //Sizes
    const fov = this.camera.fov * (Math.PI / 180)
    const height = 2 * Math.tan(fov / 2) * this.camera.position.z
    const width = height * this.camera.aspect

    this.sizes = {
      width,
      height
    }
    return this.sizes
  }

  addControls() {
    this.controls = new Orbit(this.camera, {
      target: new Vec3(0, 0, 0),
    })
  }

  //Events
  onResize() {
    // Update sizes
    this.viewport = {
      width: window.innerWidth,
      height: window.innerHeight
    }

    // Update renderer
    this.renderer.setSize(this.viewport.width, this.viewport.height)
    this.renderer.dpr = Math.min(window.devicePixelRatio, 2)
    // Update camera    
    //Doc : perspective({ near = this.near, far = this.far, fov = this.fov, aspect = this.aspect } = {})
    //Pour recuperer l'ouverture de la camera adéquate pour visualiser tout le viewport : Check awwwards course Chapitre : Sync HTML and WebGL
    //To convert radian to degrees : 1rad × 180/π = 57,296°    
    this.camera.perspective({
      aspect: this.gl.canvas.width / this.gl.canvas.height,
      fov: 2 * (Math.atan((this.viewport.height / 2) / this.camera.position.z) * (180 / Math.PI)),
    })

  }

  update() {
    //Time
    this.time += 0.01
    // Need to update controls every frame
    this.controls && this.controls.update()

    // Render
    this.renderer.render({ scene: this.scene, camera: this.camera })

    // Call update again on the next frame
    window.requestAnimationFrame(this.update.bind(this))
  }

  //Listerners
  addEventListeners() {
    //Window resize
    window.addEventListener('resize', this.onResize.bind(this))
  }

}
